<template>
    <svg
        id="Camada_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        style="enable-background: new 0 0 200 200"
        xml:space="preserve"
    >
        <g>
            <path
                d="M91.1,91.9H109c3.9,0,7-3.1,7-7V65.6c0-1.4-1.1-2.5-2.5-2.5c0,0,0,0,0,0H86.7c-1.4,0-2.5,1.1-2.5,2.5v19.3
		C84.2,88.8,87.3,91.9,91.1,91.9z M89.2,68.1H111v16.8c0,1.1-0.9,2-2,2H91.1c-1.1,0-2-0.9-2-2L89.2,68.1z"
            />
            <path
                d="M67.4,166.3h-2.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h2.5c0.7,0,1.3-0.6,1.3-1.3
		C68.7,166.9,68.1,166.3,67.4,166.3z"
            />
            <path
                d="M79.3,166.3H74c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h5.3c0.7,0,1.3-0.6,1.3-1.3C80.5,166.9,79.9,166.3,79.3,166.3
		z"
            />
            <path
                d="M126.7,166.3h-5.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h5.3c0.7,0,1.3-0.6,1.3-1.3
		C127.9,166.9,127.4,166.3,126.7,166.3z"
            />
            <path
                d="M91.1,166.3h-5.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h5.3c0.7,0,1.3-0.6,1.3-1.3
		C92.4,166.9,91.8,166.3,91.1,166.3z"
            />
            <path
                d="M114.8,166.3h-5.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h5.3c0.7,0,1.3-0.6,1.3-1.3
		C116.1,166.9,115.5,166.3,114.8,166.3z"
            />
            <path
                d="M103,166.3h-5.3c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h5.3c0.7,0,1.3-0.6,1.3-1.3
		C104.2,166.9,103.6,166.3,103,166.3z"
            />
            <path
                d="M135.8,166.3h-2.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h2.5c0.7,0,1.3-0.6,1.3-1.3
		C137,166.9,136.5,166.3,135.8,166.3z"
            />
            <path
                d="M149,96.6h-3l-6.8-4c-1.1-0.7-2.2-1.5-3.1-2.5c-6-5.7-9.4-13.8-9.4-22.3V48c0-1.4-1.1-2.5-2.5-2.5c0,0,0,0,0,0H116V33.8
		c0.1-8.8-6.9-16-15.7-16.1c-8.8-0.1-16,6.9-16.1,15.7c0,0.1,0,0.2,0,0.4v11.6h-7.6c-1.4,0-2.5,1.1-2.5,2.5v19.6
		c0,8.2-3,15.8-8.5,21.4c-1.6,1.7-3,2.9-4.2,3.6l-6.6,4h-3c-8.2,0-14.8,6.6-14.8,14.8v51.6c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5
		c0,0,0,0,0,0v-51.6c0-5.4,4.4-9.8,9.8-9.8h1.6v76.8c0,1.4,1.1,2.5,2.5,2.5h89c1.4,0,2.5-1.1,2.5-2.5v-76.8h1.6
		c5.4,0,9.8,4.4,9.8,9.8v51.6c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5v-51.6C163.8,103.2,157.2,96.6,149,96.6z M89.2,33.8
		c-0.2-6,4.5-11.1,10.5-11.3c6-0.2,11.1,4.5,11.3,10.5c0,0.3,0,0.5,0,0.8v11.6H89.2V33.8z M58.3,175.9v-75.6l5.5-3.4
		c1.6-0.9,3.3-2.4,5.2-4.4c6.4-6.6,10-15.5,10-24.9V50.5h5.1v2.2c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-2.2H111v2.2
		c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5v-2.2h5.6v17.3c0,9.9,4,19.4,11,26c1.2,1.2,2.6,2.3,4,3.2l5.7,3.4l0,75.6H58.3z"
            />
        </g>
    </svg>
</template>

<script>
    export default {
        name: 'ApronIcon',
    };
</script>
